const initialState = () => {
    return {
        iva: 0,
        total: 0,
        net_total: 0,
        arrayPayments:[],
        paymentMethodsList: [
            { text: 'Efectivo', id: 1 },
            { text: 'Débito', id: 2 },
            { text: 'Crédito', id: 3 },
            { text: 'Cheque', id: 4 },
            { text: 'Documento Banco', id: 7 },
            { text: 'Nota de Crédito', id: 8 },
        ],
        payment:'',
        paymentMethod:null,
        lastPaymentMethod:null,
        invoiceSelected:[],
        paymentDetail:null,
        banks:[],
        currentStep:1,
    }
}

export default initialState
